<ng-scrollbar [ngClass]="ngClass" [appearance]="'standard'" [position]="'invertX'"
	[autoHeightDisabled]="autoHeightDisabled" [visibility]="'native'" [track]="'all'" trackClass="ca-scrollbar">
	<ng-content></ng-content>
</ng-scrollbar>
